"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSimilarProductsSkusUseCase = void 0;
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const useIsSimilarProductsEnabled_1 = require("../../hooks/useIsSimilarProductsEnabled");
const favorites_1 = require("../../providers/favorites");
const query_1 = require("../../providers/query");
const similarProducts_1 = require("../../services/similarProducts");
const tdcClient_1 = require("../../services/tdcClient");
/**
 * Caso de uso que obtém os SKUs de produtos similares para determinados SKUs.
 */
function useGetSimilarProductsSkusUseCase({ skus, businessUnit, resellerSlug, queryContext = favorites_1.favoritesQueryClientContext, }) {
    const isSimilarProductsEnabled = (0, useIsSimilarProductsEnabled_1.useIsSimilarProductsEnabled)(resellerSlug);
    const [queryEnabled, setQueryEnabled] = (0, react_1.useState)(false);
    const enabled = (0, react_1.useMemo)(() => isSimilarProductsEnabled && queryEnabled && skus.length > 0, [isSimilarProductsEnabled, queryEnabled, skus]);
    const similarProductsService = (0, react_1.useMemo)(() => new similarProducts_1.SimilarProductsService(tdcClient_1.tdcClient), []);
    const { data } = (0, react_query_1.useQuery)({
        queryKey: query_1.SimilarProductsQueryKeys.GetBySkus(skus),
        queryFn: ({ signal }) => __awaiter(this, void 0, void 0, function* () {
            if (!enabled)
                return {};
            const similarProducts = yield similarProductsService.getBySkus({
                skus,
                catalogSlug: resellerSlug,
                businessUnit,
                abortSignal: signal,
            });
            return similarProducts !== null && similarProducts !== void 0 ? similarProducts : {};
        }),
        initialData: {},
        enabled,
        context: queryContext,
    });
    const result = (0, react_1.useMemo)(() => (enabled ? data : {}), [data, enabled]);
    const call = () => {
        setQueryEnabled(true);
    };
    return [result, call];
}
exports.useGetSimilarProductsSkusUseCase = useGetSimilarProductsSkusUseCase;
